import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiFetch, apiSearch } from '../modules/utility';
import { showErrors } from '../modules/general';

const getFleetConfig = ({ callback = _.noop } = {}) => (dispatch) => {
	apiFetch({ method: 'ticket.getFleetConfig', params: {}, dispatch, callback });
};

const searchUsers = () => (dispatch) => {
	apiSearch({ base: 'user', params: { includeHidden: true }, dispatch, callback: _.noop });
};

const mapStateToProps = (state) => ({
	userMap: state.maps.user || {},
});

const mapDispatchToProps = (dispatch) =>
	bindActionCreators({ getFleetConfig, searchUsers, showErrors }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps);
